import { io } from "socket.io-client";

import { API_URL } from "src/Common/function";
import TokenService from "src/Services/API/token.service";

let woTechStatusSocket;

const getWoTechStatusSocket = () => {
  if (!woTechStatusSocket) {
    woTechStatusSocket = io(`${API_URL}/wo-tech-status`, {
      autoConnect: false,
      transports: ["websocket"],
    });
  }

  return woTechStatusSocket;
};

const connectWoTechStatusSocket = () => {
  const socket = getWoTechStatusSocket();
  socket.auth = {
    token: TokenService.getLocalAccessToken(),
  };

  if (!socket.connected) {
    socket.connect();
  }

  return socket;
};

const disconnectWoTechStatusSocket = () => {
  if (woTechStatusSocket?.connected) {
    woTechStatusSocket.disconnect();
  }
};

export {
  getWoTechStatusSocket,
  connectWoTechStatusSocket,
  disconnectWoTechStatusSocket,
};
